import React, { Component, useEffect, useState } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { firebase } from "../../firebase/config";
import ScrollToTop from "./ScrollToTop";
import { withRouter } from "react-router-dom";
import Landing from "../Parts/Landing/Landing";
import LandingMobile from "../Parts/Landing/LandingMobile";
import Request from "../Parts/Request/Request";
import RequestMobile from "../Parts/Request/RequestMobile";
import Checkout from "../Parts/Checkout/Checkout";
import CheckoutMobile from "../Parts/Checkout/CheckoutMobile";
import "./index.css";
import { useLocation } from "react-router-dom";
import Privacy from "../Parts/Privacy/Privacy";
import Terms from "../Parts/Terms/Terms";
import TermsMobile from "../Parts/Terms/TermsMobile";
import Success from "../Parts/Success/Success";
import SuccessMobile from "../Parts/Success/SuccessMobile";
import { useAuth } from "../Parts/Context/AuthContext";
import Videos from "../Parts/Videos/Videos";
import VideosMobile from "../Parts/Videos/VideosMobile";
import Video from "../Parts/Video/Video";
import VideoMobile from "../Parts/Video/VideoMobile";
import Explore from "../Parts/Explore/Explore";
import ExploreMobile from "../Parts/Explore/ExploreMobile";
import CreateClone from "../Parts/CreateClone/CreateClone";
import CreateCloneMobile from "../Parts/CreateClone/CreateCloneMobile";
import Clones from "../Parts/Clones/Clones";
import ClonesMobile from "../Parts/Clones/ClonesMobile";

const BasePage = () => {
  const [isDesktop, setIsDesktop] = useState(0);
  const [profiles, setProfiles] = useState([]);
  const { loggedIn, loading } = useAuth();

  useEffect(() => {
    firebase
      .firestore()
      .collection("profiles")
      .where("landing", "==", true)
      .get()
      .then((querySnapshot) => {
        let empty = [];
        querySnapshot.forEach((doc) => {
          empty.push(doc.data());
        });
        setProfiles(empty);
        console.log(empty);
      });
  }, []);

  useEffect(() => {
    screenSizeDetector();
    window.addEventListener("resize", screenSizeDetector);
  }, []);

  const screenSizeDetector = () => {
    if (window.innerWidth > 900 && window.innerWidth < 1000) {
      setIsDesktop(true);
    } else if (window.innerWidth <= 900) {
      setIsDesktop(false);
    } else {
      setIsDesktop(true);
    }
  };

  if (loading === true || loggedIn === null) {
    return null;
  }

  return (
    <>
      <ScrollToTop />

      <Switch>
        <Route
          exact
          path="/"
          render={() =>
            isDesktop ? (
              <Landing profiles={profiles} />
            ) : (
              <LandingMobile profiles={profiles} />
            )
          }
        />

        {firebase.auth().currentUser && (
          <Route
            exact
            path="/checkout"
            render={() => (isDesktop ? <Checkout /> : <CheckoutMobile />)}
          />
        )}
        {firebase.auth().currentUser && (
          <Route
            exact
            path="/success"
            render={() => (isDesktop ? <Success /> : <SuccessMobile />)}
          />
        )}

        {firebase.auth().currentUser && (
          <Route
            exact
            path="/checkout"
            render={() => (isDesktop ? <Checkout /> : <CheckoutMobile />)}
          />
        )}

        <Route
          exact
          path="/request"
          render={() => (isDesktop ? <Request /> : <RequestMobile />)}
        />
        {firebase.auth().currentUser && (
          <Route
            exact
            path="/create-clone"
            render={() => (isDesktop ? <CreateClone /> : <CreateCloneMobile />)}
          />
        )}

        {firebase.auth().currentUser && (
          <Route
            exact
            path="/clones"
            render={() => (isDesktop ? <Clones /> : <ClonesMobile />)}
          />
        )}

        <Route
          exact
          path="/video"
          render={() => (isDesktop ? <Video /> : <VideoMobile />)}
        />

        <Route
          exact
          path="/explore"
          render={() =>
            isDesktop ? (
              <Explore profiles={profiles} />
            ) : (
              <ExploreMobile profiles={profiles} />
            )
          }
        />

        {firebase.auth().currentUser && (
          <Route
            exact
            path="/videos"
            render={() => (isDesktop ? <Videos /> : <VideosMobile />)}
          />
        )}

        <Route
          exact
          path="/privacy-policy"
          render={() => (isDesktop ? <Privacy /> : <PrivacyMobile />)}
        />

        <Route
          exact
          path="/terms-of-service"
          render={() => (isDesktop ? <Terms /> : <TermsMobile />)}
        />

        <Redirect to="/" />
      </Switch>
    </>
  );
};

export default withRouter(BasePage);
